import { render, staticRenderFns } from "./select-mcc.vue?vue&type=template&id=984641f0&scoped=true&"
import script from "./select-mcc.vue?vue&type=script&lang=js&"
export * from "./select-mcc.vue?vue&type=script&lang=js&"
import style0 from "./select-mcc.vue?vue&type=style&index=0&id=984641f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984641f0",
  null
  
)

export default component.exports